import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GrievanceComponent} from './_components/grievance/grievance.component';
import {GrievanceListComponent} from './_components/grievance-list/grievance-list.component';
import {MainComponent} from './_components/main/main.component';
import {RouterModule} from '@angular/router';
import {
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule, MatDatepickerModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatRadioModule,
    MatSelectModule,
    MatSnackBarModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule
} from '@angular/material';
import {RatingModule} from 'ngx-rating';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MainService} from './_services/main.service';
import {GrievanceService} from './_services/grievance.service';
import {StorageServiceModule} from 'angular-webstorage-service';
import {ProfileFilterPipe} from '../common/pipes/profile-filter.pipe';
import {MnewsDistComponent} from './mnews-dist.component';
import { ApiListComponent } from './_components/api-list/api-list.component';
import {mnewsDistRoutes} from './mnews-dist.routes';
import { AppChannelComponent } from './_components/app-channel/app-channel.component';
import {CasemanagerComponent} from './_components/casemanager/casemanager.component';
import { ConfirmBoxComponent } from './_dialog_box/confirm-box/confirm-box.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { CasemanagerItemsComponent } from './_components/casemanager-items/casemanager-items.component';
import {AssignUnassignItemsComponent} from './_components/assign-unassign-items/assign-unassign-items.component';
import { DialogLayoutComponent } from './_dialog_box/dialog-layout/dialog-layout.component';
import { ImageViewerComponent } from './_dialog_box/image-viewer/image-viewer.component';
import { JsonParsePipe } from '../common/pipes/json.pipe';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MatTabsModule,
        MatToolbarModule,
        MatGridListModule,
        MatListModule,
        MatCardModule,
        MatPaginatorModule,
        MatSelectModule,
        MatExpansionModule,
        MatInputModule,
        MatDividerModule,
        RatingModule,
        FormsModule,
        MatChipsModule,
        MatButtonModule,
        MatIconModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        MatTableModule,
        StorageServiceModule,
        MatProgressBarModule,
        RouterModule.forRoot(mnewsDistRoutes, {useHash: true}),
        MatCheckboxModule,
        MatRadioModule,
        MatDatepickerModule,
        MatDialogModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
    ],
    declarations: [MnewsDistComponent,
        MainComponent,
        GrievanceComponent,
        GrievanceListComponent,
        ProfileFilterPipe,
        ApiListComponent,
        AppChannelComponent,
        CasemanagerComponent,
        AssignUnassignItemsComponent,
        ConfirmBoxComponent,
        CasemanagerItemsComponent,
        DialogLayoutComponent,
        ImageViewerComponent,
        JsonParsePipe
    ],
    exports: [
        MainComponent
    ],
    providers: [MainService, GrievanceService],
    entryComponents: [ImageViewerComponent]
})
export class MnewsDistModule {
}
